import $ from 'jquery';
import 'parsleyjs';

if ($('body').hasClass('language-de')) {
    Parsley.addMessages('de', {
        defaultMessage: "Die Eingabe scheint nicht korrekt zu sein.",
        type: {
            email:        "Die Eingabe muss eine gültige E-Mail-Adresse sein.",
            url:          "Die Eingabe muss eine gültige URL sein.",
            number:       "Die Eingabe muss eine Zahl sein.",
            integer:      "Die Eingabe muss eine Zahl sein.",
            digits:       "Die Eingabe darf nur Ziffern enthalten.",
            alphanum:     "Die Eingabe muss alphanumerisch sein."
        },
        notblank:       "Die Eingabe darf nicht leer sein.",
        required:       "Dies ist ein Pflichtfeld.",
        pattern:        "Die Eingabe scheint ungültig zu sein.",
        min:            "Die Eingabe muss größer oder gleich %s sein.",
        max:            "Die Eingabe muss kleiner oder gleich %s sein.",
        range:          "Die Eingabe muss zwischen %s und %s liegen.",
        minlength:      "Die Eingabe ist zu kurz. Es müssen mindestens %s Zeichen eingegeben werden.",
        maxlength:      "Die Eingabe ist zu lang. Es dürfen höchstens %s Zeichen eingegeben werden.",
        length:         "Die Länge der Eingabe ist ungültig. Es müssen zwischen %s und %s Zeichen eingegeben werden.",
        mincheck:       "Wählen Sie mindestens %s Angaben aus.",
        maxcheck:       "Wählen Sie maximal %s Angaben aus.",
        check:          "Wählen Sie zwischen %s und %s Angaben.",
        equalto:        "Dieses Feld muss dem anderen entsprechen."
    });

    Parsley.setLocale('de');
}

if ($('body').hasClass('language-fr')) {
    Parsley.addMessages('fr', {
        defaultMessage: "Cette valeur semble non valide.",
        type: {
            email:        "Cette valeur n'est pas une adresse email valide.",
            url:          "Cette valeur n'est pas une URL valide.",
            number:       "Cette valeur doit être un nombre.",
            integer:      "Cette valeur doit être un entier.",
            digits:       "Cette valeur doit être numérique.",
            alphanum:     "Cette valeur doit être alphanumérique."
        },
        notblank:       "Cette valeur ne peut pas être vide.",
        required:       "Ce champ est requis.",
        pattern:        "Cette valeur semble non valide.",
        min:            "Cette valeur ne doit pas être inférieure à %s.",
        max:            "Cette valeur ne doit pas excéder %s.",
        range:          "Cette valeur doit être comprise entre %s et %s.",
        minlength:      "Cette chaîne est trop courte. Elle doit avoir au minimum %s caractères.",
        maxlength:      "Cette chaîne est trop longue. Elle doit avoir au maximum %s caractères.",
        length:         "Cette valeur doit contenir entre %s et %s caractères.",
        mincheck:       "Vous devez sélectionner au moins %s choix.",
        maxcheck:       "Vous devez sélectionner %s choix maximum.",
        check:          "Vous devez sélectionner entre %s et %s choix.",
        equalto:        "Cette valeur devrait être identique."
    });

    Parsley.setLocale('fr');
}

if ($('body').hasClass('language-es')) {
    Parsley.addMessages('es', {
        defaultMessage: "Este valor parece ser inválido.",
        type: {
            email:        "Este valor debe ser un correo válido.",
            url:          "Este valor debe ser una URL válida.",
            number:       "Este valor debe ser un número válido.",
            integer:      "Este valor debe ser un número válido.",
            digits:       "Este valor debe ser un dígito válido.",
            alphanum:     "Este valor debe ser alfanumérico."
        },
        notblank:       "Este valor no debe estar en blanco.",
        required:       "Este valor es requerido.",
        pattern:        "Este valor es incorrecto.",
        min:            "Este valor no debe ser menor que %s.",
        max:            "Este valor no debe ser mayor que %s.",
        range:          "Este valor debe estar entre %s y %s.",
        minlength:      "Este valor es muy corto. La longitud mínima es de %s caracteres.",
        maxlength:      "Este valor es muy largo. La longitud máxima es de %s caracteres.",
        length:         "La longitud de este valor debe estar entre %s y %s caracteres.",
        mincheck:       "Debe seleccionar al menos %s opciones.",
        maxcheck:       "Debe seleccionar %s opciones o menos.",
        check:          "Debe seleccionar entre %s y %s opciones.",
        equalto:        "Este valor debe ser idéntico."
    });

    Parsley.setLocale('es');

}

if ($('body').hasClass('language-zh')) {

    Parsley.addMessages('zh-cn', {
        defaultMessage: "输入似乎不正确。",
        type: {
            email:        "输入的内容必须为有效的电子邮件地址。",
            url:          "输入内容必须为有效的URL。",
            number:       "输入必须为数字。",
            integer:      "输入必须为数字。",
            digits:       "输入内容只能包含数字。",
            alphanum:     "输入必须为字母数字。"
        },
        notblank:       "输入不能为空。",
        required:       "此为必填项。",
        pattern:        "输入似乎无效。",
        min:            "输入值必须大于或等于 %s。",
        max:            "输入值必须小于或等于 %s。",
        range:          "输入值必须在 %s 和 %s 之间。",
        minlength:      "输入太短。至少需要输入 %s 个字符。",
        maxlength:      "输入过长。最多可输入 %s 个字符。",
        length:         "输入长度无效。必须输入 %s 到 %s 之间的字符。",
        mincheck:       "请至少选择 %s 项信息。",
        maxcheck:       "最多可选择 %s 项。",
        check:          "在 %s 和 %s 之间进行选择。",
        equalto:        "此字段必须与另一个字段一致。"
    });

    Parsley.setLocale('zh-cn');
}


if ($('body').hasClass('language-pl')) {
    Parsley.addMessages('pl', {
        defaultMessage: "Wartość wygląda na nieprawidłową",
        type: {
            email:        "Wpisz poprawny adres e-mail.",
            url:          "Wpisz poprawny adres URL.",
            number:       "Wpisz poprawną liczbę.",
            integer:      "Dozwolone są jedynie liczby całkowite.",
            digits:       "Dozwolone są jedynie cyfry.",
            alphanum:     "Dozwolone są jedynie znaki alfanumeryczne."
        },
        notblank:       "Pole nie może być puste.",
        required:       "Pole jest wymagane.",
        pattern:        "Pole zawiera nieprawidłową wartość.",
        min:            "Wartość nie może być mniejsza od %s.",
        max:            "Wartość nie może być większa od %s.",
        range:          "Wartość powinna zawierać się pomiędzy %s a %s.",
        minlength:      "Minimalna ilość znaków wynosi %s.",
        maxlength:      "Maksymalna ilość znaków wynosi %s.",
        length:         "Ilość znaków wynosi od %s do %s.",
        mincheck:       "Wybierz minimalnie %s opcji.",
        maxcheck:       "Wybierz maksymalnie %s opcji.",
        check:          "Wybierz od %s do %s opcji.",
        equalto:        "Wartości nie są identyczne."
    });

    Parsley.setLocale('pl');
}


if ($('body').hasClass('language-cs')) {

    Parsley.addMessages('cs', {
        defaultMessage: "Tato položka je neplatná.",
        type: {
            email:        "Tato položka musí být e-mailová adresa.",
            url:          "Tato položka musí být platná URL adresa.",
            number:       "Tato položka musí být číslo.",
            integer:      "Tato položka musí být celé číslo.",
            digits:       "Tato položka musí být kladné celé číslo.",
            alphanum:     "Tato položka musí být alfanumerická."
        },
        notblank:       "Tato položka nesmí být prázdná.",
        required:       "Tato položka je povinná.",
        pattern:        "Tato položka je neplatná.",
        min:            "Tato položka musí být větší nebo rovna %s.",
        max:            "Tato položka musí být menší nebo rovna %s.",
        range:          "Tato položka musí být v rozsahu od %s do %s.",
        minlength:      "Tato položka musí mít nejméně %s znaků.",
        maxlength:      "Tato položka musí mít nejvíce %s znaků.",
        length:         "Tato položka musí mít délku od %s do %s znaků.",
        mincheck:       "Je nutné vybrat alespoň %s možností.",
        maxcheck:       "Je nutné vybrat nejvýše %s možností.",
        check:          "Je nutné vybrat od %s do %s možností.",
        equalto:        "Tato položka musí být stejná."
    });

    Parsley.setLocale('cs');

}
